<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.specialtyId" placeholder="所属专业" @change="getLevel" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.gradeId" placeholder="级别" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.gradeName" :value="item.gradeId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.agentId" placeholder="考级点" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in agentList" :key="index" :label="item.agentName" :value="item.agentId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <!--        <el-cascader v-model="queryParam.receiverAddressInfo2" placeholder="省份地区" style="width:200px;margin-right:10px;margin-bottom: 10px;" :options="areaTreeData"-->
        <!--                     :props="{value:'areaName',label:'areaName',emitPath:true}"></el-cascader>-->
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.evaluateCertificateNo" clearable placeholder="证书编号"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" clearable placeholder="姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" clearable placeholder="证件号"></el-input>
        <el-date-picker v-model="publishTime" type="daterange" range-separator="至" start-placeholder="打印证书开始日期" end-placeholder="打印证书结束日期"
                        value-format="yyyy-MM-ddTHH:mm:ss" :default-time="['00:00:00','23:59:59']" style="width:410px;margin-right:10px;margin-bottom: 10px;"></el-date-picker>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="reset" type="default">重置</el-button>
        <el-button @click="exportExcel()" type="primary">导出</el-button>
        <!--        <KtButton @click="exportExcel()" label='导出' perms='evaluation-performance-export' type="primary"/>-->
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="evaluateCertificateNo" label="证书编号"></el-table-column>
        <el-table-column prop="examineeName" label="姓名">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye2">
              <span>
                    {{scope.row.examineeName}}
              </span>
              <i v-if="scope.row.examineeName" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye2">
              <span>
                    {{scope.row.examineeName2}}
              </span>
              <i v-if="scope.row.examineeName2" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="examineeIdNo" label="证件号">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye">
              <span>{{scope.row.examineeIdNo}}</span>
              <i v-if="scope.row.examineeIdNo" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye">
              <span>{{scope.row.examineeIdNo2}}</span>
              <i v-if="scope.row.examineeIdNo2" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="agentName" label="考级点"></el-table-column>
        <el-table-column prop="specialtyName" label="专业"></el-table-column>
        <el-table-column prop="gradeName" label="级别"></el-table-column>
        <el-table-column prop="receiverName" label="收件人">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye3">
              <span>
                    {{scope.row.receiverName}}
              </span>
              <i v-if="scope.row.receiverName" style="margin-left: 5px;" class="el-icon-view" @click="reloadName2(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye3">
              <span>
                    {{scope.row.receiverName2}}
              </span>
              <i v-if="scope.row.receiverName2" style="margin-left: 5px;" class="el-icon-view" @click="reloadName2(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="receiverPhone" label="联系方式">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye4">
              <span>{{scope.row.receiverPhone}}</span>
              <i v-if="scope.row.receiverPhone" style="margin-left: 5px;" class="el-icon-view" @click="reloadPhoneNo(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye4">
              <span>{{scope.row.receiverPhone2}}</span>
              <i v-if="scope.row.receiverPhone2" style="margin-left: 5px;" class="el-icon-view" @click="reloadPhoneNo(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="receiverAddressInfo" label="省份/地区"></el-table-column>
        <el-table-column prop="receiverAddressDetail" label="详细地址"></el-table-column>
        <el-table-column prop="teacherName" label="指导老师">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye5">
              <span>
                    {{scope.row.teacherName}}
              </span>
              <i v-if="scope.row.teacherName" style="margin-left: 5px;" class="el-icon-view" @click="reloadName3(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye5">
              <span>
                    {{scope.row.teacherName2}}
              </span>
              <i v-if="scope.row.teacherName2" style="margin-left: 5px;" class="el-icon-view" @click="reloadName3(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="teacherPhone" label="指导老师联系方式">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye6">
              <span>{{scope.row.teacherPhone}}</span>
              <i v-if="scope.row.teacherPhone" style="margin-left: 5px;" class="el-icon-view" @click="reloadPhoneNo2(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye6">
              <span>{{scope.row.teacherPhone2}}</span>
              <i v-if="scope.row.teacherPhone2" style="margin-left: 5px;" class="el-icon-view" @click="reloadPhoneNo2(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="evaluateResult" label="地址信息汇总">
          <template slot-scope="scope">
            {{scope.row.receiverName}} {{scope.row.receiverPhone}} {{scope.row.agentAddressInfo}} {{scope.row.agentAddressDetail}}
          </template>
        </el-table-column>
        <el-table-column prop="makeCertificateTime" label="打印时间"></el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <p>当前导出进度</p>
      <div style="text-align: center">
        <el-progress type="circle" :percentage="percent"></el-progress>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtButton from '../../components/ktButton'

export default {
  name: 'list',
  components: { KtButton },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      batchList: [],
      specialtyList: [],
      agentList: [],
      evaluateStatus: [],
      dialogVisible: false,
      percent: null,
      publishTime: [],
      officeList: [],
      areaTreeData: [],
      gradeList: []
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    // if (this.Tool.isNull(this.batchList)) {
    //   throw new Error('没有考试数据')
    // }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    // this.areaTreeData = await this.$HTTP.ApiCommon.getAreaTreeData()
    await this.getSpecialtyList()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
    clearInterval(this.taskInterval)
  },
  computed: {},
  watch: {},
  methods: {
    async reset () {
      this.queryParam = JSON.parse(JSON.stringify(this.oldQueryParam))
      this.publishTime = []
      this.getPage({ pageSize: this.page.pageSize })
      await this.getSpecialtyList()
      this.gradeList = []
    },
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      this.agentList = await this.$HTTP.ApiBatch.getAgentList(this.queryParam.batchId)
      if (event) {
        this.queryParam.specialtyId = ''
        this.queryParam.agentId = ''
      }
      await this.getPage()
    },
    async getLevel (event) {
      if (event) {
        this.queryParam.gradeId = ''
      }
      this.gradeList = await this.$HTTP.ApiGrade.getList({ specialtyId: this.queryParam.specialtyId, status: 2 })
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        this.queryParam.publishStartTime = ''
        this.queryParam.publishEndTime = ''
        if (this.publishTime) {
          this.$set(this.queryParam, 'startTime', this.publishTime[0])
          this.$set(this.queryParam, 'endTime', this.publishTime[1])
        }
        if (this.queryParam.receiverAddressInfo2) {
          this.queryParam.receiverAddressInfo = this.queryParam.receiverAddressInfo2.join('/')
        }
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus == 0) {
          newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
        }
        // if (queryParam && !queryParam.pageSize) {
        //   this.$set(queryParam, 'pageSize', this.page.pageSize)
        // }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        let page = await this.$HTTP.GradeExam.getPageReceiverInfo(newQueryParam)
        if (page.list) {
          page.list.map(el => {
            this.$set(el, 'examineeIdNo2', el.examineeIdNo)
            this.$set(el, 'examineeName2', el.examineeName)
            this.$set(el, 'receiverName2', el.receiverName)
            this.$set(el, 'receiverPhone2', el.receiverPhone)
            this.$set(el, 'teacherName2', el.teacherName)
            this.$set(el, 'teacherPhone2', el.teacherPhone)
            this.$set(el, 'trueEye3', true)
            this.$set(el, 'trueEye5', true)
            this.$set(el, 'trueEye6', true)
            this.$set(el, 'trueEye4', true)
            this.$set(el, 'trueEye2', true)
            this.$set(el, 'trueEye', true)
            // el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, "\$1********")
            // el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
            if (el.examineeIdNo) {
              el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, "\$1********")
            }
            if (el.examineeName) {
              el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
            }
            if (el.receiverName) {
              el.receiverName2 = el.receiverName.replace(/(?<=.)./g, '*')
            }
            if (el.teacherName) {
              el.teacherName2 = el.teacherName.replace(/(?<=.)./g, '*')
            }
            if (el.receiverPhone) {
              el.receiverPhone2 = el.receiverPhone.replace(/^(\d{3})(\d{4})(\d{4})/g, '$1****$3')
            }
            if (el.teacherPhone) {
              el.teacherPhone2 = el.teacherPhone.replace(/^(\d{3})(\d{4})(\d{4})/g, '$1****$3')
            }
          })
        }
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async reloadIdNo (index, row) {
      if (row.trueEye == true) {
        this.$set(row, 'trueEye', false)
      } else {
        this.$set(row, 'trueEye', true)
      }
    },
    async reloadName (index, row) {
      if (row.trueEye2 == true) {
        this.$set(row, 'trueEye2', false)
      } else {
        this.$set(row, 'trueEye2', true)
      }
    },
    async reloadName2 (index, row) {
      if (row.trueEye3 == true) {
        this.$set(row, 'trueEye3', false)
      } else {
        this.$set(row, 'trueEye3', true)
      }
    },
    async reloadName3 (index, row) {
      if (row.trueEye5 == true) {
        this.$set(row, 'trueEye5', false)
      } else {
        this.$set(row, 'trueEye5', true)
      }
    },
    async reloadPhoneNo (index, row) {
      if (row.trueEye4 == true) {
        this.$set(row, 'trueEye4', false)
      } else {
        this.$set(row, 'trueEye4', true)
      }
    },
    async reloadPhoneNo2 (index, row) {
      if (row.trueEye6 == true) {
        this.$set(row, 'trueEye6', false)
      } else {
        this.$set(row, 'trueEye6', true)
      }
    },
    async exportExcel (queryParam) {
      try {
        this.queryParam.publishStartTime = ''
        this.queryParam.publishEndTime = ''
        if (this.publishTime) {
          this.$set(this.queryParam, 'publishStartTime', this.publishTime[0])
          this.$set(this.queryParam, 'publishEndTime', this.publishTime[1])
        }
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus == 0) {
          newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
        }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        await this.$HTTP.GradeExam.exportReceiverInfo(newQueryParam)
        this.getTaskInfo('export_receiver_info')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamResult.getTaskInfo(taskName)
          this.percent = taskInfo.percent
          if (taskInfo) {
            if (taskInfo.status == 0 && taskInfo.status != 2) {
              this.dialogVisible = true
            }
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '操作成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              this.dialogVisible = false
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
            this.$message({ type: 'error', message: taskInfo.errMsg })
          }
          if (taskInfo.percent >= 100) {
            this.dialogVisible = false
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms)
    },
    getPermission () { // 模拟接口 获取 权限数据集合
      let perms = this.$store.state.buttonList
      // this.$store.dispatch("SET_PERMISSION", perms)
    }
  }
}
</script>
